import React, { useState } from 'react';
import { Button, Col, InputNumber, Modal, Row } from 'antd';
import { Page } from 'react-pdf';
import { Document } from 'react-pdf/dist/esm/entry.webpack';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
// import { useQuery } from 'react-query';
// import { getTemplatesbyDoccodeAndLancode } from 'services/printingService';

type PreviewModalProps = {
  onCancel: () => void;
  visible: boolean;
  doccode: string;
  url: string;
  Params: any;
};
const PreviewPrintModal = ({
  visible,
  onCancel,
  doccode,
  url,
  Params,
}: PreviewModalProps) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setscale] = useState(1);
  const onChangepdfZoom = (value: any) => {
    setscale(value / 100);
  };
  function onDocumentLoadSuccess({ numPages }: any) {
    setinfo('');
    setNumPages(numPages);
  }
  const [info, setinfo] = useState('');
  function changePage(offset: number) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }
  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      width={scale === 1 ? 610 : 610 * scale}
      destroyOnClose
      footer={null}
      className="provisiondetail"
    >
      {Params.isPDF && (
        <div>
          <Row>
            <Col>
              <InputNumber
                min={10}
                max={200}
                formatter={(value) => `${value}%`}
                step={10}
                defaultValue={100}
                onChange={onChangepdfZoom}
              />
            </Col>
          </Row>
          <h2>{info}</h2>
          <Button
            onClick={previousPage}
            icon={<LeftOutlined />}
            style={{ color: '#3755ac' }}
            disabled={numPages ? pageNumber <= 1 : false}
          />
          <Button
            disabled={numPages ? pageNumber >= numPages : false}
            onClick={nextPage}
            icon={<RightOutlined />}
            style={
              scale === 1
                ? { marginLeft: '89%' }
                : { marginLeft: `${89 + scale}%` }
            }
            name="next"
          />

          <Document
            file={url}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={() => setinfo('THERE IS NO PDF FOR THIS PRINTID')}
          >
            <Page pageNumber={pageNumber} scale={scale} />
          </Document>
          {pageNumber !== 0 && (
            <p>
              Page {pageNumber} of {numPages}
            </p>
          )}
        </div>
      )}

      {!Params.isPDF && (
        <iframe
          title="my_iframe"
          name="my_iframe"
          srcDoc={url}
          width="100%"
          height="800px"
          style={{ border: '1px solid #E3E3E3' }}
        />
      )}
    </Modal>
  );
};
export default PreviewPrintModal;
